/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_SavedInputs */

const fr_admin_subscription_rights_saved = /** @type {(inputs: Admin_Subscription_Rights_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formule mise à jour`)
};

/**

* @param {Admin_Subscription_Rights_SavedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_saved = /** @type {((inputs?: Admin_Subscription_Rights_SavedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_SavedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_saved(inputs)
});